import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import { todosFeatureKey } from '../key';
import type { TodosQueryParams } from './useTodosQuery';

const localKey = ['rails-todos'] as const;

type TodosListQueryType = GenericListQueryKey<TodosQueryParams>;

const getTodosListQueryKey = (params: TodosListQueryType) =>
  generateListQueryKey({
    prefix: [...todosFeatureKey, ...localKey],
  })(params);

export const getTodosInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getTodosListQueryKey,
});
